<template>
	<div>
		<div
			class="header-container-bar head-box"
			:style="{ backgroundColor: `rgb(16, 15, 15,${showHeader ? 1 : 0})` }"
		>
			<div class="personal-center-user" v-if="inPersonalCenter">
				<img :src="userInfo.user_head_img" alt="" />
				<div class="header-container-user-name">
					{{ userInfo.real_name || userInfo.user_code_name }}
				</div>
				<div class="out-login">
					<el-button type="danger" @click="goLogin" plain>
						<img src="@/assets/icon/tuichu.png" />
						退出登录
					</el-button>
				</div>
			</div>
			<div @mouseleave="hidden" class="content_box">
				<!-- 一级标题栏 -->
				<div class="header_box">
					<div class="left">
						<div class="logo">
							<img src="../image/logoxiao.png" @click="jumpHome" alt="" />
						</div>
						<div class="head_item">
							<div v-for="(items, index) in tab" :key="index" class="tab" ref="tab">
								<!-- <div
                @click="tabNav(index, items.url)"
                @mouseenter="show(index)"
                :class="[tabindex == index ? 'nav item' : 'item']"
              >
                {{ items.title }}{{index}}{{tabindex}}
              </div> -->
								<span
									@click="tabNav(index, items.url)"
									@mouseenter="show(index)"
									:class="[
										tabindex2 == index ? 'nav item' : 'item',
										tabindex == index ? 'activeTab' : '',
									]"
								>
									{{ items.title }}
								</span>

								<!-- 二级标题 -->
								<!-- <div class="sub-tabs" v-if="!showindex && showSecondaryCan == index && can_secondaryTitle.indexOf(items.title) != -1">
                  <div v-for="(keys, i) in ejtab" :key="i" class="tab">
                    <div
                      @click="tabNav(tabindex, keys.url, i)"
                      :class="['item', keys.showState ? 'sub_nav' : '']"
                      @mouseenter="moveInChange(i)"
                      @mouseleave="removeChange(i)"
                    >
                      <img v-show="keys.showState" :src="keys.icon1" alt="" />
                      <img v-show="!keys.showState" :src="keys.icon2" alt="" />

                      <span class="sub_title">{{ keys.title }}</span>
                    </div>
                  </div>
                </div> -->
							</div>
						</div>
					</div>

					<!-- 导航栏 用户信息 -->
					<div class="right" v-if="!inPersonalCenter">
						<!-- <div class="ztc">
              <a href="https://ztc.cdn.cc?mid=5" target="_blank">
                总裁直通车
              </a>
            </div> -->
						<div class="jtzd" @mouseenter="show('zhandian')" @mouseleave="show('zhandian')">
							<div class="zhandian" :class="tabindex == 'zhandian' ? 'activeTab' : ''">
								<img
									src="@/assets/icon/jituan-active.png"
									class="i-icon"
									alt=""
									v-if="tabindex == 'zhandian'"
								/>
								<img src="@/assets/icon/jituan.png" class="i-icon" alt="" v-else />
								集团站点
							</div>
							<div v-if="tabindex == 'zhandian'" class="zhandian-detail">
								<div class="zhandian-top"></div>
								<div
									class="zhandian-detail-item"
									v-for="(bg, bgIndex) in blogroll"
									:key="bgIndex"
									@click.stop="open(bg.url)"
								>
									{{ bg.title }}
								</div>
							</div>
						</div>
						<a class="right-item" :href="oa_url">
							<img class="i-icon" src="@/assets/icon/oa.png" alt="" />
							<img
								class="i-icon-active"
								src="@/assets/icon/oa-active.png"
								alt=""
								style="display: none"
							/>
							OA系统
						</a>
						<!-- <div v-if="loginType == 0" @click="goLogin" class="info_not">
              登录
            </div> -->
						<div v-if="loginType == 0" @click="goLogin" class="login-btn">
							<img class="i-icon" src="@/assets/icon/login-user.png" alt="" />
							<img
								class="i-icon-active"
								src="@/assets/icon/login-user-active.png"
								alt=""
								style="display: none"
							/>
							登录
						</div>
						<div v-else class="info_not_login" @mouseenter="showInfo">
							<div class="user_box" @click="goRouterPage(defaultUrl)">
								<div class="img">
									<img :src="userInfo.user_head_img" alt="" />
								</div>
								<div class="naem">{{ userInfo.real_name }}</div>
							</div>
						</div>
					</div>

					<!-- 用户信息栏  -->
					<div class="infoBox" v-if="infoBox">
						<div class="infoBox-info">
							<!-- 用户信息 -->
							<div class="info-top">
								<div class="info-top-left" @click="goRouterPage(defaultUrl)">
									<!-- 头像 -->
									<img style="width: 64px; height: 64px" :src="userInfo.user_head_img" alt="" />
								</div>
								<div class="info-top-right">
									<div class="info-name">
										<div class="user_name" @click="goRouterPage(defaultUrl)">
											{{ userInfo.real_name }}
										</div>
										<div class="user_memeber" v-if="userInfo.user_is_member_name">
											<div class="img">
												<img :src="memeberTabs[userInfo.user_is_member_name].url" alt="" />
											</div>
											<div class="text">
												{{ memeberTabs[userInfo.user_is_member_name].text }}
											</div>
										</div>
									</div>
									<div class="info-phone">{{ userInfo.user_phone }}</div>
								</div>

								<!-- 会员信息 -->
								<!-- <div class="info_member">
                <div class="member_box">
                  <div class="item" v-for="item in 4" :key="item">
                    <div class="img"><img src="@/assets/icon/putong@2x.png" alt=""></div>
                    <div class="text">普通</div>
                  </div>
                </div>
              </div> -->
							</div>

							<!-- 内容 -->
							<div class="info-bottom">
								<div class="info-integral">
									<img src="../assets/icon/jf.png" alt="" />
									{{ userInfo.user_score }}
								</div>
								<div class="line"></div>
								<div class="info-balance">
									<img src="../assets/icon/xj.png" alt="" />
									￥{{ userInfo.user_price }}
								</div>
							</div>
						</div>
						<div class="infoBox-btn">
							<div
								v-for="(item, index) in list"
								class="infoBox-btn-item"
								:key="index"
								@click="goRouterPage(item)"
							>
								<img :src="item.img" class="infoBox-img-icon" alt="" />
								<!-- 红点提示 -->
								<span :class="[item.read_status ? 'list_item_name' : '']">{{ item.name }}</span>
							</div>

							<div class="line2"></div>
							<div class="infoBox-btn-item" @click="goLogin">
								<img src="../assets/icon/tcdl@2x.png" class="infoBox-img-icon" alt="" />
								<span>退出登录</span>
							</div>
						</div>
					</div>
				</div>
				<!-- 二级标题栏 -->
				<div
					v-if="showindex && tabindex !== 'zhandian'"
					class="header_box sub_head_box"
					:name="index"
				>
					<div class="left">
						<!-- 左内边距(logo宽度+内外边距) + 75(一级导航栏外边距)*一级导航栏索引 + 导航栏边距数 -->

						<!-- <div style="width: 160px" class="logo"></div> -->
						<div v-for="(item, index) in ejtab" :key="index" class="tab" ref="subtab">
							<!-- 根据二级导航 个数 位移 -->
							<!-- (.sub_head_box 需要同步 .header_box 的边距) -->

							<div
								@click="tabNav(tabindex, item.url, index)"
								:class="['item', item.showState ? 'sub_nav' : '']"
								@mouseenter="moveInChange(index)"
								@mouseleave="removeChange(index)"
							>
								<template v-if="item.icon1 || item.icon2">
									<img v-show="item.showState" :src="item.icon1" alt="" />
									<img v-show="!item.showState" :src="item.icon2" alt="" />
								</template>

								<span class="sub_title">{{ item.title }}</span>
							</div>
						</div>
					</div>
					<!-- <div class="right"></div> -->
				</div>
			</div>
			<!--  -->
		</div>
		<!-- <div style="height: 70px" v-if="!inPersonalCenter"></div> -->
		<div class="head_box"></div>
	</div>
</template>
<script>
	import router, { routes } from '../router';
	import { $authRoleList, $getLogoContentr, $userDetail } from '@/api';
	export default {
		data: () => ({
			showSecondaryCan: '',
			can_secondaryTitle: ['智能照明', '技术服务', '关于我们'],
			userInfo: {},
			inPersonalCenter: false,

			// 会员标签
			memeberTabs: {
				普通会员: { text: '普通', url: require('@/assets/icon/putong@2x.png') },
				白银会员: { text: '白银', url: require('@/assets/icon/bojin@2x.png') },
				黄金会员: { text: '黄金', url: require('@/assets/icon/huangjin@2x.png') },
				铂金会员: { text: '铂金', url: require('@/assets/icon/bojin@2x.png') },
				钻石会员: { text: '钻石', url: require('@/assets/icon/zuanshi@2x.png') },
			},

			list: [],
			loginType: 0,
			tabindex: 0, // 当前一级导航栏索引
			tabindex2: 0, //
			tab: [
				{
					title: '首页',
					url: '/',
					name: 'Home',
					children: [],
					index: 0,
				},
				{
					title: '智能照明',
					url: '/smart_lighting',
					name: 'smart_lighting',
					children: ['smart_lighting', 'case_details', 'smart_product', 'product_detail'],
					index: 1,
					subtab: 1,
				},
				// {
				// 	title: '西顿云设计',
				// 	url: '/cloudDesign',
				// 	name: 'cloudDesign',
				// 	children: [],
				// 	index: 2,
				// },
				{
					title: '西顿舍见SMI',
					url: 'https://cdn.thethinking.cn/#/pages/login/login',
					name: 'cloudDesign',
					children: [],
					index: 2,
				},
				{
					title: '技术服务',
					url: '/training_services',
					name: 'training_services',
					children: ['training_services', 'technical_services', 'coursed_details', 'sign_up'],
					index: 3,
					subtab: 2,
				},
				{
					title: '关于我们',
					url: '/aboutIntroduce',
					name: 'aboutIntroduce',
					children: ['aboutIntroduce', 'aboutUs', 'helpDetails'],
					index: 4,
					subtab: 3,
				},
			],
			user_code_id: 0,
			ejtab: [],
			tab1: [
				{
					title: '智能产品',
					// url: "/smart_lighting/#smart_title", // 锚点跳转
					url: '/smart_product', // 路径跳转
					icon1: require('@/assets/icon/hyfa1.png'), // 选中
					icon2: require('@/assets/icon/hyfa2.png'), // 未选中
					showState: false,
					anchor: '#smart_title',
					// name: "#smart_title",  // 锚点跳转 name
					name: ['smart_product', 'product_detail'],
				},
				{
					title: '设计素材',
					url: '/smart_lighting/#dasgin_title',
					icon1: require('@/assets/icon/cpzs1.png'),
					icon2: require('@/assets/icon/cpzs2.png'),
					showState: false,
					anchor: '#dasgin_title',
					name: ['#dasgin_title'],
				},
				// {
				// 	title: '家装案例',
				// 	// url: "/smart_lighting/#dasgin_share",
				// 	url: 'https://www.kujiale.com/pub/site/design-zone/3D7RG7YHD3UG/designs?kpm=qkWL.8411f11a25ad0e71.1f62acb.1688463005503',
				// 	icon1: require('@/assets/icon/alfx1.png'),
				// 	icon2: require('@/assets/icon/alfx2.png'),
				// 	showState: false,
				// 	anchor: '#dasgin_share',
				// 	name: ['#dasgin_share', 'case_details'],
				// },
			],
			tab2: [
				{
					title: '设计下单',
					url: '/technical_services',
					name: ['technical_services'],
					icon1: require('@/assets/icon/sjxd1.png'),
					icon2: require('@/assets/icon/sjxd2.png'),
					showState: false,
				},
				{
					title: '技术培训',
					url: '/training_services',
					name: ['training_services', 'coursed_details', 'sign_up'],
					icon1: require('@/assets/icon/jspx1.png'),
					icon2: require('@/assets/icon/jspx2.png'),
					showState: false,
				},
			],
			tab3: [
				{
					title: '关于我们',
					url: '/aboutIntroduce',
					name: ['aboutIntroduce'],
					icon1: require('@/assets/icon/gywm1.png'),
					icon2: require('@/assets/icon/gywm2.png'),
					showState: false,
				},
				{
					title: '帮助中心',
					url: '/aboutUs',
					name: ['aboutUs', 'helpDetails'],
					icon1: require('@/assets/icon/bzzx1.png'),
					icon2: require('@/assets/icon/bzzx2.png'),
					showState: false,
				},
			],

			showindex: 0,
			infoBox: false,

			subTabShow: false,
			subindex: -1, // 记录二级导航栏 索引
			index: -1, // 记录一级导航栏 索引

			oa_url: '', // OA 跳转链接

			marginLeft: 0, // 二级导航栏边距数

			defaultUrl: {}, // 默认跳转订单页
		}),
		computed: {
			showHeader() {
				return true;
				if (this.$route.name !== 'Home') {
					return true;
				}
				return this.$store.state.showHeader;
			},
			headPlaceholder() {
				if (this.$route.name !== 'Home') {
					return true;
				}
				return this.$store.state.headPlaceholder;
			},
			blogroll() {
				return this.$store.getters.blogroll.map((item) => {
					return {
						...item,
						title: item.label,
					};
				});
			},
		},
		mounted() {
			// window.onscroll = (event) => {
			//   console.log(event);
			// }
		},
		created() {
			// console.log('header', this);
			let autoLoginCheck = this.$store.state.checked;
			let cacheUserInfo;

			if (!autoLoginCheck) {
				cacheUserInfo = sessionStorage.getItem('cdntoken');
			} else {
				cacheUserInfo = this.$store.state.userInfo.token;
			}
			let path_search_token = GetQueryString('token');

			let post_name_data = GetQueryString('post_name');
			let dec_url = '';
			if (post_name_data) {
				dec_url = post_name_data.substr(decodeURIComponent(post_name_data).indexOf('?'));
			}

			if (path_search_token) {
				cacheUserInfo = path_search_token || GetPathParmasString(dec_url, 'token');
				this.$store.commit('SetUserInfo', { token: cacheUserInfo });
				this.$store.commit('SetChecked', true);
			}

			if (cacheUserInfo) {
				cacheUserInfo = JSON.parse(JSON.stringify(cacheUserInfo));
				// this.$store.commit("clearUserInfo");

				this.loginType = 1;
				// 更新 用户信息
				$userDetail({})
					.then((res) => {
						if (res) {
							// if (GetQueryString("token")) {
							//   this.$store.commit("SetChecked", true);
							// }
							this.$store.commit('SetUserInfo', {
								...res.data,
								token: cacheUserInfo,
							});
							this.getUserInfo();
							this.getSideBar();
						}
					})
					.catch((err) => {
						console.log(err);
					});
			} else {
				this.loginType = 0;
			}

			this.getUrl();

			let routes = this.$route;
			if (
				routes.matched.length >= 2 &&
				routes.matched[0].components &&
				routes.matched[0].components.default.name == 'PersonalCenter'
			) {
				this.inPersonalCenter = true;
			} else {
				this.inPersonalCenter = false;
			}
		},
		watch: {
			$route: {
				handler: function (val, oldVal) {
					this.forChange(this.tab1).forChange(this.tab2).forChange(this.tab3);

					if (
						val.matched.length >= 2 &&
						val.matched[0].components &&
						val.matched[0].components.default.name == 'PersonalCenter'
					) {
						// console.log("隐藏");
						this.inPersonalCenter = true;
					} else {
						this.inPersonalCenter = false;
					}

					this.showindex = 0;
					this.subindex = -1; // 重置 二级导航
					let forState = false;

					// 一级导航选中  刷新
					this.tab.forEach((item, index) => {
						let bool;
						if (item.children.length) {
							// 二级导航选中  刷新
							this['tab' + item.subtab].forEach((item3, index3) => {
								if (
									item3.name.filter((item) => item == val.name).length ||
									item3.anchor == val.hash
								) {
									item3.showState = true;
									this.subindex = index3; // 设置 二级导航
								}
							});

							// 判断是否 是子路由
							bool =
								item.name == val.name ||
								item.children.filter((item2) => {
									return item2 == val.name;
								}).length;
						} else {
							bool = item.name == val.name;
						}
						if (bool) {
							this.tabindex = item.index;
							this.tabindex2 = item.index; // 记录 页面一级导航
							forState = true;
						} else {
							if (forState) return;
							this.tabindex = -1;
							this.tabindex2 = -1; // 进入个人中心导航
						}
					});

					// if (val.name == "Home") {
					//   this.forChange(this.tab1).forChange(this.tab2).forChange(this.tab3);
					// }
				},
				// 深度观察监听
				deep: true,
			},
		},
		methods: {
			// 获取 OA跳转链接
			getUrl() {
				$getLogoContentr()
					.then((res) => {
						// console.log('获取链接', res);
						this.oa_url = res.data.url;
					})
					.catch((err) => {
						console.log(err);
					});
			},

			getUserInfo() {
				if (!(JSON.stringify(this.$store.state.userInfo) == '{}')) {
					this.userInfo = this.$store.state.userInfo;
					let user_code_id = this.$store.state.userInfo.user_code;

					if (user_code_id == 6) {
						this.tab2.shift();
					}
				}
			},

			goRouterPage(ev) {
				// console.log(ev);
				this.$router.push({
					path: ev.route.path,
				});
				this.infoBox = false;
			},
			getSideBar() {
				// 获取 跳转页面列表
				$authRoleList({}).then((res) => {
					if (res) {
						this.$data.list = res.data.map((item) => {
							// if (item.name=="订单管理") this.defaultUrl = item;
							// 查找 路由对应 跳转路径
							item.route = routes.find(function checkRoute(val) {
								return val.children && val.children[0].meta.title == item.name;
							});
							// 单独 查找 我的资料 跳转个人信息
							if (item.name == '我的资料') {
								item.route = routes.find(function checkRoute(val) {
									return val.children && val.children[0].meta.title == '个人信息';
								});
							}
							item.img = require('../assets/icon/' + `w_${item.icon}`);
							item.imgActive = require('../assets/icon/' + item.activity_icon);
							return item;
						});
						let bool = res.data.find((item) => {
							return item.name == '订单管理';
						});
						bool ? (this.defaultUrl = bool) : (this.defaultUrl = res.data[0]);
						// console.log(this.defaultUrl.name, "----");

						this.$store.commit('setPermissions', res.data);
					}
				});
			},
			goLogin() {
				this.$store.commit('clearUserInfo');
				this.$router.push('/login');
				this.infoBox = false;
			},
			hiddenInfo() {
				this.infoBox = false;
			},
			showInfo() {
				this.infoBox = true;
			},

			// 一级导航栏 移入事件
			show(e) {
				// this.showSecondaryCan = e;
				this.index = e;
				this.marginLeft = 0;
				this.tabindex = e; // 当前一级导航栏索引
				this.infoBox = false;

				if (e == 1) {
					this.ejtab = this.tab1;
				} else if (e == 3) {
					this.ejtab = this.tab2;
				} else if (e == 4) {
					this.ejtab = this.tab3;
				} else if (e === 'zhandian') {
					// console.log(this.blogroll);
					// this.ejtab = this.blogroll;
				} else {
					this.ejtab = [];
					this.showindex = 0;
					return;
				}

				this.showindex = 1;

				let arr = this.$refs['tab'];
				let sum = 0;
				arr.forEach((item, index) => {
					if (index < e) {
						sum += item.offsetWidth;
					}
				});
				this.marginLeft = sum;
				// console.log(this.marginLeft);
			},
			// 导航栏 移出事件
			hidden() {
				this.index = -1;
				this.showindex = 0;
				this.tabindex = this.tabindex2;
				this.infoBox = false;

				this.marginLeft = 0;
			},
			tabNav(e, url, subindex) {
				this.subindex = -1;
				this.tabindex = e;
				this.tabindex2 = e;

				this.forChange(this.tab1).forChange(this.tab2).forChange(this.tab3);

				if (subindex != undefined) {
					// 修改二级导航栏 索引状态
					this.ejtab[subindex].showState = true;
					this.subindex = subindex;

					// 登录页面限制  导航项重置
					if (url == ('/technical_services' || '/aboutUs') && !this.userInfo.token) {
						this.tabindex = 0;
						this.tabindex2 = 0;

						this.subindex = -1;
						// console.log(this.ejtab);
						// this.ejtab[subindex].showState = false;
					}
				}
				if (this.tabindex === 'zhandian') {
					window.open(url);
					return;
				}
				if (url.indexOf('https') !== -1 || url.indexOf('http') !== -1) {
					window.location.href = url;
				} else {
					this.$router.push(url);
				}
			},
			//
			open(url) {
				window.open(url);
			},

			// 修改状态
			forChange(arr) {
				arr.forEach((item) => {
					if (item.showState) {
						item.showState = false;
					}
				});

				return this;
			},

			moveInChange(index) {
				// 二级标题 鼠标移入
				this.ejtab[index].showState = true;
			},
			removeChange(index) {
				// 二级标题 鼠标移出
				// 判断 移入的二级索引 和 记录的二级索引 并且 移入的一级索引 和 记录的一级索引 是否相等
				if (index == this.subindex && this.tabindex2 == this.tabindex) return;
				this.ejtab[index].showState = false;
			},
			jumpHome() {
				this.$router.push('/');
			},
		},
	};

	function GetQueryString(name) {
		var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
		var r = window.location.search.substr(1).match(reg);
		if (r != null) return unescape(r[2]);
		return null;
	}
	function GetPathParmasString(path, name) {
		var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
		var r = path.substr(1).match(reg);
		if (r != null) return unescape(r[2]);
		return null;
	}
</script>
<style lang="scss" scoped>
	@font-face {
		font-family: 'iconfont';
		src: url('../assets/iconfont/iconfont.woff2?t=1657593709086') format('woff2'),
			url('../assets/iconfont/iconfont.woff?t=1657593709086') format('woff'),
			url('../assets/iconfont/iconfont.ttf?t=1657593709086') format('truetype');
	}
	.iconfont {
		font-family: 'iconfont' !important;
		font-size: 16px;
		font-style: normal;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
	}

	.header-container-bar {
		// position: relative;

		// position: -webkit-sticky; //ios必加
		// position: sticky !important;
		top: 0;
		left: 0;
		position: fixed;
		z-index: 888;
		width: 100%;

		min-width: 1150px;
		transition: all 0.7s;
		&:hover {
			background: rgb(16, 15, 15, 1) !important;
		}
	}
	// ----------------------------
	// .out-login {
	//   display: none;
	//   position: absolute;
	//   bottom: -80px;
	//   left: -10px;

	//   background: rgba(0, 0, 0, 0.4);
	//   padding: 20px 10px;
	// }
	// .personal-center-user:active,
	// .personal-center-user:hover {
	//   .out-login {
	//     display: inline-block;
	//   }
	// }

	.out-login {
		display: none;
		position: absolute;
		bottom: -46px;
		left: -12px;
		padding-top: 8px;
		line-height: 38px;

		.el-button {
			border: none;
			border-radius: 4px;
			font-size: 16px;
			color: #333333;

			background: #f5f5f5;
			box-shadow: 3px 3px 6px 0px rgb(0 0 0 / 15%);
			img {
				width: 20px;
				height: 20px;
				margin-right: 4px;
			}
		}
	}
	.personal-center-user:active,
	.personal-center-user:hover {
		.out-login {
			display: inline-block;
			opacity: 0.9;
		}
	}

	// ----------------------------

	.personal-center-user {
		position: absolute;
		top: 0px;
		right: 20px;
		z-index: 9999;
		height: 100%;
		width: 120px;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #100f0f;

		.header-container-user-name {
			cursor: pointer;
			width: 80px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			font-size: 0.42rem;
			font-family: PingFangSC-Regular;
			color: #fff;
		}
		img {
			margin-right: 10px;
			width: 30px;
			height: 30px;
			border-radius: 50%;
			border: 1px solid rgba(255, 255, 255, 0.1);
			cursor: pointer;
		}
	}

	.content_box {
		position: relative;
	}

	.header_box {
		display: flex;
		box-sizing: border-box;
		// padding: 10px calc(var(--proportion) * 160px);
		padding: 10px 10%;
		min-width: 1100px;
		justify-content: space-between;
		position: relative;
		.infoBox {
			position: absolute;
			top: 60px;
			right: 0;
			background-color: rgba(0, 0, 0, 0.8);
			z-index: 90;
			.infoBox-info {
				padding: 20px 20px 25px;
				padding-right: 10px;

				.info-top {
					margin-bottom: 30px;
					display: flex;
					align-items: center;
					.info-top-left {
						cursor: pointer;
						// margin-left: 12px;
						margin-right: 14px;
						img {
							width: 64px;
							border-radius: 50px;
							height: 64px;
						}
					}

					// 用户信息展示
					.info-top-right {
						.info-name {
							margin-bottom: 10px;
							font-size: 0.72rem;
							font-weight: bold;
							color: #ffffff;

							display: flex;
							align-items: center;
							.user_name {
								cursor: pointer;
								max-width: 140px;
								overflow: hidden;
								text-overflow: ellipsis;
								word-break: keep-all;
								white-space: nowrap;
								margin-right: 10px;
							}
						}
						.info-phone {
							font-size: 0.48rem;
							font-weight: 500;
							color: #ffffff;
						}
					}
				}

				.info-bottom {
					display: flex;
					justify-content: space-around;
					align-items: center;
					font-size: 0.48rem;
					font-weight: 500;
					color: #ffffff;
					.info-integral {
						box-sizing: border-box;
						flex: 1;
						display: flex;
						align-items: center;
						justify-content: center;
					}
					.info-balance {
						flex: 1;
						display: flex;
						align-items: center;
						justify-content: center;
						// border-left: 1px solid #ccc;
						// padding-left: 20px;
						// margin-left: 45px;
					}
					img {
						margin-right: 10px;
					}
				}
			}
			.infoBox-btn {
				// margin-top: 23px;
				.infoBox-btn-item:hover {
					opacity: 0.9;
					background: #ffffff10;
				}
				.infoBox-btn-item:active {
					opacity: 0.7;
				}
				.infoBox-btn-item {
					cursor: pointer;
					// margin-bottom: 28px;
					width: 100%;
					height: 48px;
					line-height: 48px;
					font-size: 0.48rem;

					font-weight: 400;
					color: #ffffff;
					padding-left: 24px;
					// padding-left: calc(24rem / 33);
					span {
						color: #ffffff;
						margin-left: 24px;
						// margin-left: calc(24rem / 33);
					}
				}
				.infoBox-btn-item:last-child {
					margin: 10px 0;
					// margin-top: 50px;
					// margin-bottom: 18px;
					// padding-top: 20px;
				}
			}
		}
		.left {
			flex: 1;
			display: flex;
			align-items: center;

			.logo {
				margin-right: 81px;
				img{
					width: 160px;
				}
			}
			.head_item {
				flex: 1;
				display: flex;
				justify-content: center;
				padding-right: calc(var(--proportion) * 50px);
				margin-top: 8px;
				.tab {
					margin-right: calc(var(--proportion) * 75px);
					position: relative;
					&::before,
					&::after {
						content: '';
						background: #e60000;
						position: absolute;
						height: 2px;
						bottom: 0;
						width: 0;
						transition: width 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
					}
					&::before {
						right: 50%;
					}
					&::after {
						left: 50%;
					}
					&:hover {
						&::before,
						&::after {
							width: 50%;
							transition: width 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
						}
					}
				}
			}

			.tab {
				display: flex;
				// font-size: 0.48rem;
				font-size: 16px;

				margin-right: 5%;
				.item:hover {
					color: #e60000 !important;
				}
				.item {
					display: flex;
					align-items: center;
					padding-bottom: 8px;
					color: #ffffff;
					// opacity: 0.7;
					cursor: pointer;
					white-space: nowrap;
					a {
						display: inline-block;
						margin-left: 5px;
						color: #ffffff;
					}
					img {
						// margin: auto 0;
						margin-right: 5px;
						width: 24px;
						height: 24px;
					}
					// .sub_title:hover {
					//   color: #e60000;
					// }
				}
				.nav {
					// position: relative;
					color: #e60000 !important;
					// font-weight: bold;
					border-bottom: 2px solid #e60000;
					// &::before {
					//   position: absolute;
					//   content: "";
					//   width: 100%;
					//   height: 20px;
					//   top: 8px;
					// }
				}
				.sub_nav {
					color: #e60000;
				}
			}
		}
		.infoBox-img-icon {
			position: relative;
			top: -1.5px;
			width: calc(var(--proportion) * 20px);
			height: calc(var(--proportion) * 20px);
		}
		.right {
			display: flex;
			align-items: center;
			cursor: pointer;
			.icon {
				margin-right: 32px;
				width: 30px;
				height: 30px;
				box-sizing: border-box;
				a {
					display: flex;
					justify-content: center;
					align-items: center;
					width: 30px;
					height: 30px;
					// overflow: hidden;
				}
				// img {
				//   width: 100%;
				//   height: 100%;
				//   border-radius: 50%;
				//   image-rendering: auto;
				//   -webkit-font-smoothing: antialiased;
				// }
				.iconfont {
					font-size: 30px;
					color: #ffffff;
					opacity: 0.5;
					-webkit-font-smoothing: antialiased;
				}
			}
			.zhandian {
				font-size: 16px;
				color: #ffffff;
				display: flex;
				align-items: center;
				// font-weight: bold;
				margin-right: 32px;
				white-space: nowrap;
				.z-icon {
					width: 17px;
					height: 15px;
					margin-right: 5px;
				}
			}
			.jtzd {
				position: relative;
			}
			.zhandian-detail {
				position: absolute;
				right: 15px;
				top: 22px;
				background: #000000;
				// opacity: 0.5;
				.zhandian-top {
					height: 20px;
					background-color: rgba(0, 0, 0, 0.5);
					z-index: 99;
				}
				.zhandian-detail-item {
					padding: 12px 10px;
					font-size: 16px;
					color: #ffffff;
					display: flex;
					justify-content: center;
					align-items: left;
					white-space: nowrap;
					&:hover {
						background: #e60000;
					}
				}
			}
			.info_not {
				font-size: 0.42rem;

				font-weight: 500;
				color: #ffffff;
				width: 72px;
				height: 36px;
				background: #e60000;
				text-align: center;
				line-height: 36px;

				overflow: hidden;
				text-overflow: ellipsis;
				word-break: keep-all;
				white-space: nowrap;
			}
			.login-btn {
				font-size: 16px;
				color: #fff;
				display: flex;
				align-items: center;
				// font-weight: bold;
				.icon {
					width: 17px;
					height: 18px;
					margin-right: 6px;
				}
				&:hover {
					color: #e60000;
					.i-icon {
						display: none;
					}
					.i-icon-active {
						display: block !important;
					}
				}
			}

			.info_not_login {
				.user_box {
					display: flex;
					align-items: center;
					.img {
						margin-right: 10px;
						width: 18px;
						height: 18px;
						display: flex;
						align-items: center;
						justify-content: center;
						box-sizing: border-box;
						img {
							width: 100%;
							height: 100%;
							border-radius: 50%;
							overflow: hidden;
						}
					}
					.naem {
						max-width: 140px;
						font-size: 16px;

						font-weight: 500;
						color: #ffffff;
						line-height: 28px;

						overflow: hidden;
						text-overflow: ellipsis;
						word-break: keep-all;
						white-space: nowrap;
					}
				}
			}
		}
	}

	.user_memeber {
		display: flex;
		align-items: center;
		width: 56px;
		height: 22px;
		background: #ffffff15;
		border-radius: 4px;
		.img {
			flex-shrink: 0;
			display: flex;
			align-items: center;
			height: 100%;
			padding: 0 5px;
			box-sizing: border-box;
			img {
				flex-shrink: 0;
				width: 14px;
				height: 14px;
			}
		}
		.text {
			display: flex;
			align-items: center;
			height: 100%;
			font-size: 12px;

			font-weight: 400;
			color: #ffffff80;
			line-height: 28px;
		}
	}

	.line {
		margin-right: 4px;
		width: 2px;
		height: 21px;
		background: #ffffff;
		opacity: 0.2;
	}

	.line2 {
		width: 100%;
		height: 1px;
		background: #212123;
		// margin-top: 10px;
	}

	// 二级导航栏
	.sub_head_box {
		position: fixed;
		width: 100%;
		background-color: #100f0f;
		margin-left: 0;
		// padding-left: calc(var(--proportion) * 160px);
		padding-left: 60px;
		box-sizing: border-box;
		z-index: 998;
		.left {
			display: flex;
			justify-content: center;
			.tab {
				margin: 0;
				padding: 0 2.5%;
			}
		}
		// .tab:hover .sub_title {
		//   color: #e60000;
		// }

		.tab .sub_title {
			margin-left: 8px;
		}
	}

	.activeTab {
		color: $theme-color !important;
	}

	// 消息红点
	.list_item_name {
		position: relative;
		&::before {
			position: absolute;
			right: -12px;
			top: 50%;
			transform: translateY(-50%);

			content: '';
			width: 6px;
			height: 6px;
			background: #e60000;
			border-radius: 50%;
		}
	}

	.head_box {
		min-height: 54px;
		height: calc(var(--proportion) * 64px);
	}

	// .sub-tabs{
	//   min-width: 100px;
	//   position: absolute;
	//   bottom: -100%;
	//   transform: translateX(-47%);
	//   display: flex;
	//   height: 40px;
	//   .tab{
	//     margin-right: 0px !important;
	//     min-width: 100px;
	//     width: 200px;
	//     display: flex;
	//     justify-content: center;
	//   }
	// }
	// .tab{
	//   position: relative;
	// }

	// 头部导航栏 限宽居中
	.head-box {
		left: auto;
		max-width: 1920px;
		margin: 0 auto;
	}
	.ztc {
		color: #fff;
		font-size: 16px;
		margin-right: 32px;
		a {
			color: #fff;
			opacity: 0.7;
			&:hover {
				color: #e60000;
			}
		}
	}
	.right-item {
		font-size: 16px;
		color: #fff;
		display: flex;
		align-items: center;
		// font-weight: bold;
		margin-right: 32px;
		white-space: nowrap;
		a {
			color: #fff;
		}
		&:hover {
			color: #e60000;
			.i-icon {
				display: none;
			}
			.i-icon-active {
				display: block !important;
			}
		}
	}
	.i-icon {
		width: 14px;
		height: 14px;
		margin-right: 6px;
	}
	.i-icon-active {
		width: 14px;
		height: 14px;
		margin-right: 6px;
	}
</style>
